import { useEffect, useRef } from "react";

const WIDGET_ID = "ra-reservation-form-v2-c62d5182500166491c148461e85648db";
const SENDER_NAME = "reservation-form-c62d5182500166491c148461e85648db";
const SRC =
  "https://roomadmin.pl/widget/reservation-v2/start?fh=1592140fbe0869b4a76a108791c0c4baa93a98f6&style=%7B%22color_accent%22%3A%22%23735239%22%2C%22color_bg%22%3A%22%23FAF6EE%22%2C%22color_panel_header%22%3A%22%23FAF6EE%22%2C%22color_panel_body%22%3A%22%23FFFFFF%22%2C%22rounded_corners%22%3A%22true%22%7D&filter=%7B%7D&lang=pl";

export default function ReservationWidget() {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    function raMessageReceiver(event) {
      if (!event.data || !event.data.sender || event.data.sender !== SENDER_NAME) {
        return;
      }
      if (event.data.height) {
        iframe.style.height = event.data.height + 10 + "px";
      }
      if (event.data.event && event.data.event.name === "widget.scrollup.requested") {
        try {
          iframe.scrollIntoView({ behavior: "smooth", block: "start" });
        } catch (e) {
          /* noop */
        }
      }
    }

    function setup() {
      try {
        iframe.contentWindow.postMessage(
          {
            location: window.location.toString(),
            setup: {
              autoHeight: true,
              senderName: SENDER_NAME,
            },
          },
          "*"
        );
      } catch (e) {
        /* noop */
      }
    }

    window.addEventListener("message", raMessageReceiver, false);
    const interval = setInterval(setup, 1000);
    iframe.addEventListener("load", setup);

    return () => {
      window.removeEventListener("message", raMessageReceiver, false);
      clearInterval(interval);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      id={WIDGET_ID}
      title="Formularz rezerwacji JATKA NO1"
      data-testid="reservation-widget-iframe"
      src={SRC}
      style={{
        width: "100%",
        height: "560px",
        border: "none",
        padding: 0,
        background: "transparent",
      }}
    />
  );
}
